import React, { FC, useState, useEffect, useMemo, useCallback } from 'react';
import { useHistory, useParams, useRouteMatch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useProfile, bProfile, ProfileRole } from '@brg/auth';
import { FInter, useIsMobile, useToasts, FlexBox, Dropdown, DropdownListItem, Colors, useBreakpoint, HintTooltip } from "@brg/ui";
import { API, Competition, CompetitionAPI, Endpoints } from "@brg/api";
import {
  MainBlock,
  HeaderBlock,
  TitleText,
  HeaderRightBlock,
  HeaderBlockNotAuto,
  SmthTitle,
  TitleTextNotAuto,
  SmthBanner,
  SmthIconsWrapperNotAuto,
  CompetitionTagsContainer,
  ButtonsWrapper,
} from './style';
import { scrollFunc } from './utils';
import './opencallsPage.css';
import { PSLongread } from 'shared/pages/project/sections/ps-longread';
import ActionsButtons, { CompetitionDisableBtnStatus } from './ActionsButtons';
import { STATUSES } from '_competition/const';
import { SlideNavigation } from 'shared/components/slideNavigation';
import useQueryState from 'shared/hooks/useQueryState';
import { CompetitionJuryPage } from '_competition/pages/JuryPage/CompetitionJuryPage';
import { CompetitionProjectsPage } from '_competition/pages/ProjectsPage/CompetitionInfoPage';
import { ShortListPage } from '_competition/pages/ShortListPage/ShortListPage';
import { EncodedStateFilter, useEncodedStateFilter } from 'shared/components/Filters';
import { isCompetitionHasFinalyst } from 'shared/helpers/competitionStatus';
import { HseContextActions } from "../../../reducers/hseCurrentContext";
import { useDispatch } from "react-redux";
import { AGEYTOMESH_TAG_ID } from 'shared/constants/misc';
import { LimitedLink, StatusPseudoTag } from 'shared/pages/project/project';
import { CreateLinkTo, LinkTo } from 'shared/constants/linkTo';
import { BTag } from 'core/components';
import { bTag, LayoutConst } from 'core';
import { DeadLineWarningWrapper, IconCompetitionSpecial } from 'shared/assets/styles';
import ShareIcon from 'shared/assets/32/ShareIcon';
import { BottomOuterMobile } from 'shared/components/template/project-display-layout';
import { TagsMobBtn } from 'shared/components/TagsMobBtn/TagsMobBtn';
import TagsMobile from 'shared/pages/project/components/TagsMobile';
import ArrowTopIconWithText from 'shared/icons/ArrowTopIconWithText';
import styled, { ThemeProvider, useTheme, css } from 'styled-components';
import { ApprovedIcon } from 'shared/icons/ApprovedIcon';
import { CompetitionView } from '_competition/pages/AllCompetitionsPage/CompetitionView';
import { CopyIcon } from './assets/CopyIcon';
import { COMPETITION_STATUSES, getCompetitionStatus } from "../../../../_competition/helpers/getCompetitionStatus";
import WarningIcon from "../../../icons/WarningIcon";
import { createThemeByColor } from "../../../helpers/coloring";
import { CustomBgWrapper } from "../../../components/CustomBgWrapper/CustomBgWrapper";
import { MobileFilterRow, MobileFilterSort } from 'shared/pages/explore/exploreView';
import { SortIcon } from 'shared/icons';
import { ProjectsSearchBar } from 'shared/components/projectsSearchBar/projectsSearchBar';
import { SortingTypeIndex } from 'shared/constants/sortingType';
import { AppTester } from 'supporting';
import { MagicBoxRow } from "../../../components/tagAdminProjectsSearchBar/tagAdminProjectsSearchBar";
import ResizedImageEnhanced from "../../../components/ResizedImageEnhanced";
import { useGetLimitSendCompetition } from 'shared/hooks/useGetLimitSendCompetition';
import { HsePolicies } from 'shared/constants/HsePolicies';
import { CompetitionEditFrameForbidden } from 'shared/components/error-frames';
import { PreShortListPage } from '_competition/pages/ShortListPage/PreShortListPage';
import ReactTooltip from "react-tooltip";
import { getTooltipStyles, tooptipStylesWhite } from "../../../constants/tooptipStyles";
import { BTagsGridNew } from "../../../../core/components/bTag/bTagsGridNew/bTagsGridNew";
import { SendProjectButton } from '_competition/components/SendProjectButton';
import { useModal } from 'core';
import { AccessModalTypes } from 'shared/modals/AccessModal/AccessModal';
import { useAuth } from 'core/auth';
import MetaTags from 'shared/components/MetaTags';

const BRIEF_ERROR_FORBIDDEN_MSG = 'This user is not approved to view this competition'

export enum TABS {
  about = 'about',
  jury = 'jury',
  projects = 'projects',
  shortlist = 'shortlist'
}
export enum SPECIALTABS {
  about = 'about',
  jury = 'jury',
  projects = 'projects',
  select = 'shortlist',
  shortlist = 'finalists',
}
export const CUSTOMTABS: { [key: string]: string } = {
  '1': 'about',
  '2': 'jury',
  '3': 'projects',
  '4': 'shortlist'
};

const DropdownText = styled(FInter.SmallTextBoldMagic) <{ isActive?: boolean, isDark?: boolean, isAcademy?: boolean }>`
  font-size: 13px;
  line-height: 18px;
  font-weight: 600;
  letter-spacing: -0.02em;
  
  ${({ isActive, theme, isDark, isAcademy }) => isActive ? css`
    color: ${isAcademy ? Colors.geoWhite100 : isDark ? theme.icon.hoverSpecialActive : theme.icon.active};
  ` : null}
`;
const TabletSortWrapper = styled(FlexBox)`
  gap: 8px;
  
`

const getUrl = (encodedState: string, ctx?: boolean) => {
  if (ctx) {
    const id = window.location.pathname.split('/')[2];
    return `/competition/${id}/context/${encodedState}`;
  }
  return `${window.location.pathname}`
}

interface CompetitionPageProps {
  id?: string;
}

// TODO потом удалить, Нурс временно попросил!!!!
export const COMPETITIONS_WITH_OPEN_PROJECTS = ['0439ccbea0944f25a6ea380c0c465bd6']

export const CompetitionPage: FC<CompetitionPageProps> = (props) => {
  //const isMobile = useIsMobile();
  const [{ tab }] = useQueryState();

  return (
    // <EncodedStateFilter getUrl={getUrl} ctx={isMobile && tab && tab === 'projects'}>
    <EncodedStateFilter getUrl={getUrl} ctx={tab && tab === 'projects'}>
      <GetCompetitionItem {...props} />
    </EncodedStateFilter>
  )
};

const GetCompetitionItem: FC<CompetitionPageProps> = ({ id: externalId }) => {
  const { id = externalId } = useParams<{ id: string }>();
  const { i18n, t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();
  const isMobile = useIsMobile();
  const is744BP = useBreakpoint(LayoutConst.screen.s);
  const is743BP = useBreakpoint(LayoutConst.screen.s - 1);
  const isMac13 = useBreakpoint(LayoutConst.screen.mac13);
  const theme1 = useTheme();
  const profile = useProfile();
  const { info } = useToasts();
  const breakpoint = useBreakpoint(576);
  const auth = useAuth();
  const modal = useModal();
  const {
    sorting,
    setSorting,
  } = useEncodedStateFilter();
  const [selectedTab, setSelectedTab] = useState('about');
  const [scroll, setScroll] = useState(false);
  const [target, setTarget] = useState('');
  const [briefForbiddenError, setBriefForbiddenError] = useState<any>(null)
  const [competition, setCompetition] = useState<Competition<'Local'>>();
  const [showMobileTags, setShowMobileTags] = useState(false);
  const [time, setTime] = useState(Date.now());
  const [isLoading, setIsLoading] = useState(false);
  const isAcademy = AppTester.isAcademy();
  const isGreenAward = AppTester.isGreenAward();
  const isDamuseum = AppTester.isDaMuseum();
  const isHSEDesign = AppTester.isHSEDesign();
  const isCompetitionRoute = !!useRouteMatch(LinkTo.competition);

  // const [customBGStorage, setCustomBGStorage] = useState(localStorage.getItem('lastCompetitionBG'))

  const customBGStorage = localStorage.getItem('lastCompetitionBG')

  const isCompetitionCompleted = useMemo(() => (competition && isCompetitionHasFinalyst(competition)), [competition])

  const initialTab = useMemo(() => (isCompetitionCompleted ? TABS.shortlist : TABS.about), [isCompetitionCompleted])

  const [{ tab: queryTab = initialTab, unrated }, setQueryParams] = useQueryState();
  const competitionStatus = getCompetitionStatus(competition);
  const bgColor = useMemo(() => (isAcademy ? '#2A3034' : (competition?.competitionColorTheme?.backgroundColor === '#FEFEFE' && competition?.isAutomatic) ? theme1.competition.bg : competition?.competitionColorTheme?.backgroundColor) || '#FEFEFE', [competition, theme1, isAcademy])

  const { theme, isDarkText } = createThemeByColor(bgColor, theme1);
  const isDarkTheme = useMemo(() => !isDarkText, [isDarkText])

  const [{ allowedInfo, allowedStatus }] = useGetLimitSendCompetition(competition ?? {} as Competition<'Local'>);

  // @ts-ignore
  const showPreShortList = competition?.nominations?.[0]?.showPreShortList;

  useEffect(() => {
    dispatch(HseContextActions.set({
      tabs: TABS,
      initialTab,
    }));
    return () => {
      dispatch(HseContextActions.reset({}));
    }
  }, [TABS, dispatch])


  useEffect(() => {
    if (!profile && queryTab !== initialTab) {
      setQueryParams({ tab: TABS.about }, { replace: true });
    }
  }, [profile])

  const [activeTabKey, setActiveTabKey] = useState(queryTab);

  const isModer = useMemo(() => {
    if (profile && competition) {
      const hasPolicyCompetitionModer = profile.rolesList && Array.isArray(profile.rolesList)
        && (new ProfileRole(HsePolicies.access_competitions)).containsIn(profile.rolesList);

      return (bProfile.isModer(profile) || hasPolicyCompetitionModer ||
        competition?.moderatorID?.includes(profile?.accountId) ||
        competition?.administratorID?.includes(profile?.accountId)
      )
    }
  }, [profile, competition])



  const isBriefModer = useMemo(() => ((profile && profile.rolesList && Array.isArray(profile.rolesList)
    && (new ProfileRole(HsePolicies.access_brief_competitions)).containsIn(profile.rolesList)) || undefined), [profile])

  const isCanSubmitOnBrief = useMemo(
    () => competition && !!competition?.isBriefCompetition &&
      allowedInfo && allowedInfo?.includes(CompetitionDisableBtnStatus.max_briefs), [competition, allowedInfo])

  //@ts-ignore
  const isAllowParticipants = useMemo(() => (competition?.allowEmptyParticipantRequests), [competition])

  const isParticipant = useMemo(
    //@ts-ignore
    () => (competition && competition?.participantAccountIds?.includes(profile?.accountId)), [competition, profile])

  const isPendingParticipant = useMemo(
    //@ts-ignore
    () => (competition && competition?.pendingParticipantsIds?.includes(profile?.accountId)), [competition, profile])

  const isJurySectionNeed = useMemo(() => (competition && competition.juryID && competition?.juryID?.length > 0), [competition]);
  const isProjectsTabsNeed = useMemo(
    () => (
      (competition && profile && competition?.juryID?.includes(profile?.accountId)) ||
      isModer || !!(isBriefModer && competition?.isBriefCompetition) || COMPETITIONS_WITH_OPEN_PROJECTS.includes(competition?.competitionId || '')), [competition, profile, isModer, isBriefModer])

  const hasFinalistText = useMemo(
    //@ts-ignore
    () => (![STATUSES.Open, STATUSES.Announcement].includes(competition?.status) && (!!competition?.winnerText_Final?.length || !!competition?.winnerText_Intro?.length)
    ), [competition]
  )

  const isCanViewPreRegistration = useMemo(
    //@ts-ignore
    () => (!!competition?.isPreRegistration && !competition?.participantAccountIds?.includes(profile?.accountId) && competition?.status === STATUSES.Open), [profile, competition])

  const isCanSubmitProjects = useMemo(
    () => (
      /*isParticipant || */
      isPendingParticipant ||
      (isCanSubmitOnBrief && !isModer) ||
      (!!allowedInfo?.length && !isModer
      ) ||
      competition?.status !== STATUSES.Open
    )
    , [
      isParticipant,
      competition,
      isCanSubmitOnBrief,
      isModer,
      isPendingParticipant,
      allowedInfo
    ]);

  // const isCanSubmitProjects = false
  const isJury = useMemo(() => profile && competition?.juryID?.includes(profile?.designerId), [competition, profile]);
  const isVsContext = useMemo(() => (competition && competition?.contexts?.includes('hsevisualresearch')), [competition]);
  const isCompetitionModer = useMemo(() => profile && competition?.moderatorID?.includes(profile?.designerId), [competition, profile]);

  // const isDarkTheme = useMemo(() => (competition?.competitionColorTheme?.backgroundColor === '#FEFEFE' && competition?.isNewType), [competition])
  const smHeight = useMemo(() => (window.innerHeight < LayoutConst.screen.height.projectCover), [])
  const is1440 = useMemo(() => (isMac13 || smHeight), [isMac13, smHeight]);

  const canViewCompetitionPoint = useMemo(() => (
    (isJury && isVsContext) || isModer || isCompetitionModer), [isJury, isCompetitionModer, isVsContext, isModer]);

  const onMobileSortingChange = useCallback(() => {
    setSorting(Number(sorting) === 1 ? 2 : 1);
    setTime(Date.now())
  }, [sorting])

  const onSortingChange = useCallback((s: SortingTypeIndex): void => {
    setSorting(s);
    setTime(Date.now());
  }, [setSorting])

  const searchBar = useMemo(
    () => (
      <ProjectsSearchBar
        isLoading={false}
        isCategoriesHidden={true}
        hideRightButtons
        hideLeftBar
        sorting={sorting}
        // hideRightBar={true}
        onSortingChange={onSortingChange}
        onToggleUnrated={() => { }}
        sortingMethods={canViewCompetitionPoint ? [1, 2, 13, ...(isJury ? [] : [])] : [1, 2]}
        isDarkTheme={isDarkTheme}
      />
    ),
    [onSortingChange, sorting, isMobile, sorting, canViewCompetitionPoint, isDarkTheme],
  );

  const MobileSearchBar = useMemo(
    () => (
      <MobileFilterRow
        // fixed={isMobile}
        importantWidth
        style={{
          marginTop: 0,
          justifyContent: 'flex-end',
          paddingTop: '0px',
          width: '100% !important'
        }}
      >
        <MobileFilterSort onClick={() => onMobileSortingChange()}>
          <SortIcon />
          {t(`sorting_type.${Number(sorting) === 1 ? 'latest' : Number(sorting) === 2 ? 'popular' : 'score'}`)}
        </MobileFilterSort>
      </MobileFilterRow>
    ), [isMobile, sorting])


  const UnratedBar = useMemo(() => {
    if (!(isJury && (activeTabKey === TABS.projects))) {
      return null;
    }
    return (
      <FlexBox style={{ justifyContent: 'flex-end', width: isMobile ? '100%' : 'initial' }} offsetTopMobile={0} offsetTop={is743BP ? 24 : 0} offsetRight={isMobile ? 0 : 16} offsetRightMobile={0}>
        <MagicBoxRow
          label={t('filter.unrated')}
          // checked={extraFilter?.globalType?.includes('employee') || extraFilter?.globalType?.length === 0}
          checked={Boolean(unrated)}
          style={{ margin: isMobile ? '0' : '0 0 0 0', color: isHSEDesign ? theme.text.label : theme.inputs.disabledColor }}
          onClick={() => {

            setQueryParams({
              unrated: unrated === 'true' ? '' : 'true',
              page: 1
            })
          }}
        />
      </FlexBox>
    )
  }, [unrated, setQueryParams, isMobile, activeTabKey, isJury])


  const competitionTabs = useMemo(() => {
    const tabs: Record<string, string> = {};
    const specialTabs: Record<string, string> = {};
    const infoTabs: Record<string, string> = {};
    if (showPreShortList) {
      Object.entries(SPECIALTABS).forEach(([key, val]) => {
        specialTabs[key] = t(`competition.tabs.${val}`)
      })
      return specialTabs
    }

    // @ts-ignore
    if (competition?.infoTabs?.length) {
      // @ts-ignore
      competition?.infoTabs.forEach(({ name, tabId, enable }: { name: string; tabId: string, enable: boolean }) => {

        if (isModer) {
          // временный костыль, ждем правки бэка
          if (CUSTOMTABS[tabId] === 'shortlist' && name === 'Шортлист') {
            infoTabs[CUSTOMTABS[tabId]] = t('competition.tabs.shortlist');
          } else {
            infoTabs[CUSTOMTABS[tabId]] = name;
          }
          return;
        }
        // временный костыль, ждем правки бэка
        if (enable || tabId === '1' || (tabId === '3' && isJury)) {
          if (CUSTOMTABS[tabId] === 'shortlist' && name === 'Шортлист') {
            infoTabs[CUSTOMTABS[tabId]] = t('competition.tabs.shortlist');
          } else {
            infoTabs[CUSTOMTABS[tabId]] = name;
          }
        }
      });
      return infoTabs;
    }

    Object.entries(TABS).filter((i) => {
      if (
        (i.includes('jury') && !isJurySectionNeed) ||
        (i.includes('projects') && !isProjectsTabsNeed) ||
        (i.includes('shortlist') && (!isCompetitionCompleted && !hasFinalistText))) {
        return false
      } else return i;
    }).map(([key, val]) => {
      tabs[key] = t(`competition.tabs.${val}`)
    })

    if (Object.keys(tabs)?.length === 1) {
      return {};
    }

    return tabs;
  }, [
    isJurySectionNeed,
    isCompetitionCompleted,
    isProjectsTabsNeed,
    hasFinalistText,
    is743BP,
    // @ts-ignore
    competition?.infoTabs,
    showPreShortList,
    isModer,
    isJury,
    t
  ]);
  //@ts-ignore
  const isPaidCompetition = useMemo(() => competition?.lmsModuleProjectId && competition?.isPaidApplication, [competition])

  const actionButtonVisible = useMemo(() => {
    if (isPaidCompetition) {
      return false
    }
    if (!!isModer || !!(isBriefModer && competition?.isBriefCompetition)) {
      return competitionStatus < COMPETITION_STATUSES.full_finish
    }

    return (competitionStatus === COMPETITION_STATUSES.default
      || competitionStatus === COMPETITION_STATUSES.deadline_soon)
  }, [competitionStatus])

  useEffect(() => {
    setActiveTabKey(queryTab);
  }, [queryTab]);

  useEffect(() => {
    if (id) {
      setIsLoading(true);
      CompetitionAPI.Get({ idCompetition: id, initWinner: true })
        .then((v) => v.json())
        .then((v) => {
          //@ts-ignore
          if (v?.['ErrorStatusCode'] === 500 && v?.['ErrorMessage'] === BRIEF_ERROR_FORBIDDEN_MSG) {
            //@ts-ignore
            setBriefForbiddenError(true)
            return;
          }
          return API.toLang<Competition<'Local'>>(v, i18n.language)
        })
        .then(setCompetition)
        .finally(() => {
          if (isGreenAward) {
            setTimeout(() => setIsLoading(false), 1000)
          } else {
            setIsLoading(false)
          }
        })

    }
  }, [id, i18n.language]);

  useEffect(() => {
    const updateActiveOnScroll = (value: string) => {
      setTarget("");
      setScroll(true);
      setSelectedTab(value);
    };

    const handler = () => {
      const { scrollHeight, clientHeight } = document.documentElement;
      const { scrollY } = window;

      if (scrollY + 1 >= scrollHeight - clientHeight) {
        updateActiveOnScroll('contacts');
      } else if (scrollY <= 800) {
        setTarget("");
        setScroll(false);
        setSelectedTab('about');
      } else if (scrollY > 800 && scrollY <= 1200 && !is744BP) {
        updateActiveOnScroll('about');
      } else if (scrollY > 1200 && scrollY <= 1500 && !is744BP) {
        updateActiveOnScroll('timing');
      } else if (scrollY > 800 && scrollY <= 1200 && is744BP) {
        updateActiveOnScroll('timing');
      } else if (scrollY > 1900 && scrollY <= 2600 && !is744BP) {
        updateActiveOnScroll('terms');
      } else if (scrollY > 1200 && scrollY <= 2400 && is744BP) {
        updateActiveOnScroll('terms');
      } else if (scrollY > 2600 && scrollY <= 4200) {
        updateActiveOnScroll('marks');
      } else if (scrollY > 2400 && scrollY <= 6800 && is744BP) {
        updateActiveOnScroll('marks');
      } else if (scrollY > 4200 && scrollY <= 5900 && !is744BP) {
        updateActiveOnScroll('prize');
      } else if (scrollY > 6800 && scrollY <= 7300 && is744BP) {
        updateActiveOnScroll('prize');
      } else if (scrollY > 5900 && scrollY <= 6200 && !is744BP) {
        updateActiveOnScroll('contacts');
      } else if (scrollY > 7300 && is744BP) {
        updateActiveOnScroll('contacts');
      }
    };

    window.addEventListener('scroll', handler);
    scrollFunc(target, is744BP);

    return () => {
      window.removeEventListener('scroll', handler);
    };
  }, [target, selectedTab, scroll, is744BP]);

  const titleImages = useMemo(() => {
    if (competition?.isBilingual) {
      return i18n.language === 'en' ? competition?.titleImages_en : competition?.titleImages
    }
    return competition?.titleImages;
  }, [competition, i18n.language])

  //хардкод для для конкурса
  const showArrowTabIcon = useMemo(() => {
    return competition && competition?.competitionId === '43bd8964119e473c9944c1ef43aee6f2'
  }, [competition])

  const isBriefPreregistration = useMemo(
    () => (!!competition?.isBriefCompetition && !!competition?.isPreRegistration && isCanViewPreRegistration), [competition, isCanViewPreRegistration])

  const buttonText = useMemo(
    () => {
      if (!!competition?.isBriefCompetition && !!competition?.isPreRegistration) {
        return t(`hse_showcases_title.competitions.msg.${isCanViewPreRegistration ? 'go_requests' : 'send_project'}`)
      }

      return competition?.enrollButtonText
    }, [t, competition, isCanViewPreRegistration])



  const handleCopy = () => {
    const linkText = window.location.href;
    navigator.clipboard.writeText(linkText)
      .then(() => {
        info(t('notifications.copy_msg-success'))
      })
      .catch(err => {
        info(t('notifications.copy_msg-error'))
      });
  }

  const handlePaidCompetitionClick = useCallback(() => {
    if (!profile) {
      auth.login();
    } else {
      API.request()
        .endpoint(Endpoints.geoGateway)
        .url('/api/LMS/RequestToJoinCourse')
        .addQuery('projectId', competition?.lmsModuleProjectId)
        .post()
        .send()
        .then(() => {
          modal.show("access", {
            type: AccessModalTypes.LMS,
            projectId: competition?.lmsModuleProjectId
          });
        })

    }
  }, [profile, auth, modal]);

  // Обработчики событий
  const onTabChange = (tab: string) => {
    if (isDamuseum && !isCompetitionRoute) {
      history.push(CreateLinkTo.competition(competition?.competitionId ?? ''))
    }
    setQueryParams({ tab });
  }

  const backgroundColor = isGreenAward
    ? 'linear-gradient(to right, #23423F, #87B444)'
    : (
      isAcademy
        ? '#2A3034'
        : (
          (competition?.competitionColorTheme?.backgroundColor === '#FEFEFE'
            && competition?.isAutomatic)
            ? theme.competition.bg
            : competition?.competitionColorTheme?.backgroundColor
        )
        || undefined
    )


  if (briefForbiddenError) {
    return (
      <CompetitionEditFrameForbidden id={''} />
    )
  }

  return (
    <>
      <MetaTags
        title={competition?.title}
        images={competition?.titleImages}
      />
      <ThemeProvider theme={theme as any}>
        <CustomBgWrapper isCompetition backgroundColor={
          backgroundColor
        }
        >
          <MainBlock isMobile={is744BP} isAcademy={isAcademy}>
            {competition?.isNewType ? (
              <HeaderBlock isMobile={is744BP}>
                <CompetitionView competition={competition} />
                <HeaderRightBlock isMobile={is744BP}>
                  <FlexBox width="100%" direction='column' directionMobile="column">
                    {/* {competition?.title && <TitleText isMobile={is743BP}>{competition?.title}</TitleText>} */}
                    {!is743BP && (<BTagsGridNew customShadowColor={backgroundColor} shadow>
                      {
                        competitionStatus === COMPETITION_STATUSES.full_finish || competitionStatus === COMPETITION_STATUSES.apply_finish ?
                          <StatusPseudoTag onClick={(e: any) => {
                            e.preventDefault()
                            e.stopPropagation()
                          }} mr={16} mb={12}>
                            {
                              t(competitionStatus === COMPETITION_STATUSES.full_finish ?
                                'competition.statuses.Competition_ended'
                                :
                                'competition.statuses.Competition_apply_ended')
                            }
                          </StatusPseudoTag>
                          :
                          undefined
                      }
                      {competition && [...competition.requredTags, ...competition.regularTags].map((v) => {
                        // @ts-ignore
                        const target = (v.tagId === AGEYTOMESH_TAG_ID || v.isTeamTag) ? '_blank' : '';
                        return (
                          // <LimitedLink key={v.tagId} to={CreateLinkTo.tag(v.tagId)} target={target}>

                          <BTag tag={v} educational={v.isEducationTag} organization={v.isTeamTag} isProjectsTag>
                            {bTag.title(v)}
                            <ReactTooltip {...getTooltipStyles(theme as any)} />

                          </BTag>
                          // </LimitedLink>
                        )
                      })}
                    </BTagsGridNew>)}
                  </FlexBox>
                  <FlexBox width="100%" direction='column' justify={'end'} directionMobile={'column'}>

                    {is743BP && (<FlexBox>
                      <BottomOuterMobile>
                        {
                          competitionStatus === COMPETITION_STATUSES.full_finish || competitionStatus === COMPETITION_STATUSES.apply_finish ?
                            <StatusPseudoTag
                              onClick={(e: any) => {
                                e.preventDefault()
                                e.stopPropagation()
                              }}
                              mr={8}>
                              {
                                t(competitionStatus === COMPETITION_STATUSES.full_finish ?
                                  'competition.statuses.Competition_ended'
                                  :
                                  'competition.statuses.Competition_apply_ended')
                              }
                            </StatusPseudoTag>
                            :
                            undefined
                        }
                        <FlexBox directionMobile='row'>
                          <FlexBox offsetRight={'12px'}>
                            <IconCompetitionSpecial onClick={handleCopy}>
                              <ShareIcon />
                            </IconCompetitionSpecial>
                          </FlexBox>
                        </FlexBox>
                        {!![...competition?.requredTags, ...competition?.regularTags]?.length && (
                          <div className="BottomOuterMobileActions">
                            <FlexBox directionMobile="row" gxMobile={12}>
                              <TagsMobBtn isCompetition customText={t('tags_mobile_btn_text').toLowerCase()} onClick={setShowMobileTags} flag={showMobileTags} />
                            </FlexBox>
                          </div>
                        )}
                      </BottomOuterMobile>

                    </FlexBox>)}
                    {is743BP && showMobileTags && (<FlexBox offsetTopMobile={'10px'}>
                      <TagsMobile show={showMobileTags}>
                        {competition && [...competition.requredTags, ...competition.regularTags].map((v) => {
                          // @ts-ignore
                          const target = (v.tagId === AGEYTOMESH_TAG_ID || v.isTeamTag) ? '_blank' : '';
                          return (
                            <LimitedLink key={v.tagId} to={CreateLinkTo.tag(v.tagId)} target={target}>
                              {/*@ts-ignore*/}
                              <BTag tag={v} educational={v.isEducationTag} organization={v.isTeamTag} isProjectsTag>
                                {bTag.title(v)}
                              </BTag>
                            </LimitedLink>
                          )
                        })}
                      </TagsMobile>
                    </FlexBox>)}
                    {!isMobile && competitionStatus === COMPETITION_STATUSES.deadline_soon && <DeadLineWarningWrapper>
                      <div><WarningIcon /></div>
                      <span>{t('competition.ten_days-remain_msg')}</span>
                    </DeadLineWarningWrapper>}
                    <FlexBox direction='row' directionMobile={'column'} width={'100%'} widthMobile={'100%'} justify='space-between' justifyMobile='space-between' align='flex-end' alignMobile='flex-start'>

                      {!is744BP && (
                        <FlexBox offsetBottom={0} offsetBottomMobile={16} direction='column' directionMobile='row' justifyMobile='space-between' widthMobile={'100%'} alignMobile='center' style={{ placeItems: 'center' }}>
                          <IconCompetitionSpecial onClick={handleCopy} style={{ marginBottom: 0, marginTop: (!isMobile && (competitionStatus === COMPETITION_STATUSES.default || competitionStatus === COMPETITION_STATUSES.deadline_soon)) ? 24 : 0 }}>
                            <ShareIcon />
                          </IconCompetitionSpecial>
                          {isMobile && competitionStatus === COMPETITION_STATUSES.deadline_soon && (
                            <DeadLineWarningWrapper>
                              <div><WarningIcon /></div>
                              <span>{t('competition.ten_days-remain_msg')}</span>
                            </DeadLineWarningWrapper>
                          )}
                        </FlexBox>
                      )}
                      {is743BP && competitionStatus === COMPETITION_STATUSES.deadline_soon && <DeadLineWarningWrapper>
                        <div><WarningIcon /></div>
                        <span>{t('competition.ten_days-remain_msg')}</span>
                      </DeadLineWarningWrapper>}
                      {actionButtonVisible && <FlexBox justify='flex-end' justifyMobile='flex-start' widthMobile={'100%'} offsetTopMobile={is744BP ? (showMobileTags ? 14 : 24) : 0}>
                        <ActionsButtons
                          isModer={!!isModer || !!(isBriefModer && competition?.isBriefCompetition)}
                          id={competition?.competitionId}
                          contexts={competition?.contexts}
                          //@ts-ignore
                          isPreRegistration={isCanViewPreRegistration}
                          isBriefPreregistration={isBriefPreregistration}
                          nominationId={competition?.nominationsID?.[0]}
                          disabled={isCanSubmitProjects && !isGreenAward}
                          isAllowParticipants={isAllowParticipants}
                          fullWidth={false}
                          needAuth={!profile}
                          //@ts-ignore
                          text={buttonText}
                          allowedInfo={allowedInfo}
                          allowedStatus={allowedStatus}
                        />
                      </FlexBox>}
                      {isPaidCompetition && (
                        <HintTooltip
                          text={t('hints.paid_competition_hint')}
                          positionY='top'
                          onWhiteBg
                        >
                          <SendProjectButton
                            color={theme.competition.buttonText}
                            className='moder-button'
                            c={theme.competition.buttonBg}
                            hoverC={theme.competition.secondaryText}
                            onClick={handlePaidCompetitionClick}
                            r="3"
                          >
                            {t('competition.request_member')}
                          </SendProjectButton>
                        </HintTooltip>
                      )}

                    </FlexBox>
                  </FlexBox>
                </HeaderRightBlock>
              </HeaderBlock>
            ) : (
              <HeaderBlockNotAuto isMobile={is744BP}>
                <FlexBox direction="column" directionMobile='column-reverse'>
                  <SmthTitle isMobile={is744BP}>
                    <TitleTextNotAuto isMobile={is744BP}>{competition?.title}</TitleTextNotAuto>
                  </SmthTitle>
                  <SmthBanner isMobile={is744BP}>
                    <ResizedImageEnhanced files={titleImages} />
                  </SmthBanner>
                </FlexBox>
                <FlexBox width="100%" height={'auto'} justify='space-between' justifyMobile='flex-end' direction='row' directionMobile='column-reverse'
                  style={{ maxWidth: '1152px', placeItems: 'end' }}>
                  <SmthIconsWrapperNotAuto>
                    <CopyIcon onClick={handleCopy} />
                  </SmthIconsWrapperNotAuto>
                  {actionButtonVisible && competition && <ActionsButtons
                    isModer={!!isModer || !!(isBriefModer && competition?.isBriefCompetition)}
                    id={competition?.competitionId}
                    contexts={competition?.contexts}
                    disabled={isCanSubmitProjects}
                    //@ts-ignore
                    isPreRegistration={isCanViewPreRegistration}
                    isAllowParticipants={isAllowParticipants}
                    isBriefPreregistration={isBriefPreregistration}
                    nominationId={competition?.nominationsID?.[0]}
                    fullWidth={breakpoint}
                    needAuth={!profile}
                    //@ts-ignore
                    text={buttonText}
                    allowedInfo={allowedInfo}
                    allowedStatus={allowedStatus}
                  />}
                </FlexBox>
              </HeaderBlockNotAuto>
            )}
            {is743BP && UnratedBar}
            <FlexBox width={'100%'} offsetTopMobile={16} offsetBottomMobile={'16px'} offsetBottom={!is1440 ? 4 : 0} justifyMobile='end'>
              {is743BP ? (
                <>
                  <FlexBox directionMobile='row' justifyMobile='space-between' widthMobile={'100%'} alignMobile='center'>
                    {!!Object.keys(competitionTabs)?.length && (
                      <Dropdown
                        offsetY={-2}
                        hideArrow
                        dark={isDarkTheme}
                        orientation={'left'}
                        target={
                          <ArrowTopIconWithText
                            fill={isDarkTheme ? theme.competition.secondaryText : undefined}
                            isCompetition={true}
                            text={competitionTabs[activeTabKey]}
                            shrimpIcon
                          />
                        }
                      >
                        {Object.keys(competitionTabs)?.map((key) => {
                          return (
                            <div key={key} onClick={() => {
                              if (key === activeTabKey) return false;
                              onTabChange(key);
                            }}>
                              <DropdownListItem
                                justify='space-between'
                                isActive={key === activeTabKey}
                              >
                                <DropdownText isDark={!!competition?.isNewType} isAcademy={isAcademy} isActive={key === activeTabKey}>
                                  {competitionTabs[key]}
                                </DropdownText>
                                <ApprovedIcon fill={theme.icon.active} display={key === activeTabKey} />
                              </DropdownListItem>
                            </div>
                          )
                        }
                        )}
                      </Dropdown>
                    )}
                    {activeTabKey === TABS.projects && MobileSearchBar}

                  </FlexBox>
                </>
              ) : (
                <FlexBox width={'100%'} offsetTop={!competition?.isNewType ? 20 : 0}>
                  <SlideNavigation
                    items={competitionTabs}
                    activeIndexKey={activeTabKey}
                    onChange={onTabChange}
                    //хардкод стрелки для конкруса
                    arrowIconId={showArrowTabIcon ? 'projects' : ''}
                    padding={24}
                    capitalize={true}
                  />
                  <TabletSortWrapper>
                    {UnratedBar}
                    {activeTabKey === TABS.projects && (isMobile ? MobileSearchBar : searchBar)}
                  </TabletSortWrapper>

                </FlexBox>
              )}
            </FlexBox>
            {(
              activeTabKey === TABS.about ? (
                <FlexBox offsetTopMobile={4} width={'100%'}>
                  {/*@ts-ignore*/}
                  <PSLongread project={competition} />
                </FlexBox>
              ) : activeTabKey === TABS.jury ? (
                <CompetitionJuryPage openLikeTab externalId={externalId} />
              ) : activeTabKey === TABS.projects ? (
                <CompetitionProjectsPage openLikeTab mobileSorting={sorting} onMobileSortingChange={setSorting} isDarkTheme={isDarkTheme} externalId={externalId} />
              ) : activeTabKey === TABS.shortlist ? (
                <ShortListPage showPreShortList={showPreShortList} openLikeTab externalId={externalId} />
              ) : activeTabKey === 'select' ? (
                <PreShortListPage activeTabKey={activeTabKey} showPreShortList={showPreShortList} openLikeTab externalId={externalId} />
              ) : (
                <>
                  {/*@ts-ignore*/}
                  <PSLongread project={competition} />
                </>
              )
            )}
            {!isLoading && actionButtonVisible && !(['projects', 'shortlist'].includes(queryTab)) && <ButtonsWrapper isMobile={is744BP} justify='flex-end' justifyMobile='flex-start' widthMobile={'100%'} offsetTopMobile={is744BP ? (showMobileTags ? 14 : 24) : 0}>
              <ActionsButtons
                isModer={!!isModer || !!(isBriefModer && competition?.isBriefCompetition)}
                id={competition?.competitionId}
                contexts={competition?.contexts}
                //@ts-ignore
                isPreRegistration={isCanViewPreRegistration}
                isBriefPreregistration={isBriefPreregistration}
                nominationId={competition?.nominationsID?.[0]}
                disabled={isCanSubmitProjects}
                isAllowParticipants={isAllowParticipants}
                fullWidth={false}
                needAuth={!profile}
                //@ts-ignore
                text={buttonText}
                allowedInfo={allowedInfo}
                allowedStatus={allowedStatus}
              />
            </ButtonsWrapper>}
          </MainBlock>
        </CustomBgWrapper>
      </ThemeProvider>
    </>
  );
};

export default GetCompetitionItem;
import React, { FC, useState, useEffect, useMemo, useCallback } from 'react';
import { useHistory, useParams, useRouteMatch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useProfile, bProfile, ProfileRole } from '@brg/auth';
import { FInter, useIsMobile, useToasts, FlexBox, Dropdown, DropdownListItem, Colors, useBreakpoint, HintTooltip } from "@brg/ui";
import { API, Competition, CompetitionAPI, Endpoints } from "@brg/api";
import {
  MainBlock,
  HeaderBlock,
  TitleText,
  HeaderRightBlock,
  HeaderBlockNotAuto,
  SmthTitle,
  TitleTextNotAuto,
  SmthBanner,
  SmthIconsWrapperNotAuto,
  CompetitionTagsContainer,
  ButtonsWrapper,
} from './style';
import { scrollFunc } from './utils';
import './opencallsPage.css';
import { PSLongread } from 'shared/pages/project/sections/ps-longread';
import ActionsButtons, { CompetitionDisableBtnStatus } from './ActionsButtons';
import { STATUSES } from '_competition/const';
import { SlideNavigation } from 'shared/components/slideNavigation';
import useQueryState from 'shared/hooks/useQueryState';
import { CompetitionJuryPage } from '_competition/pages/JuryPage/CompetitionJuryPage';
import { CompetitionProjectsPage } from '_competition/pages/ProjectsPage/CompetitionInfoPage';
import { ShortListPage } from '_competition/pages/ShortListPage/ShortListPage';
import { EncodedStateFilter, useEncodedStateFilter } from 'shared/components/Filters';
import { isCompetitionHasFinalyst } from 'shared/helpers/competitionStatus';
import { HseContextActions } from "../../../reducers/hseCurrentContext";
import { useDispatch } from "react-redux";
import { AGEYTOMESH_TAG_ID } from 'shared/constants/misc';
import { LimitedLink, StatusPseudoTag } from 'shared/pages/project/project';
import { CreateLinkTo, LinkTo } from 'shared/constants/linkTo';
import { BTag } from 'core/components';
import { bTag, LayoutConst } from 'core';
import { DeadLineWarningWrapper, IconCompetitionSpecial } from 'shared/assets/styles';
import ShareIcon from 'shared/assets/32/ShareIcon';
import { BottomOuterMobile } from 'shared/components/template/project-display-layout';
import { TagsMobBtn } from 'shared/components/TagsMobBtn/TagsMobBtn';
import TagsMobile from 'shared/pages/project/components/TagsMobile';
import ArrowTopIconWithText from 'shared/icons/ArrowTopIconWithText';
import styled, { ThemeProvider, useTheme, css } from 'styled-components';
import { ApprovedIcon } from 'shared/icons/ApprovedIcon';
import { CompetitionView } from '_competition/pages/AllCompetitionsPage/CompetitionView';
import { CopyIcon } from './assets/CopyIcon';
import { COMPETITION_STATUSES, getCompetitionStatus } from "../../../../_competition/helpers/getCompetitionStatus";
import WarningIcon from "../../../icons/WarningIcon";
import { createThemeByColor } from "../../../helpers/coloring";
import { CustomBgWrapper } from "../../../components/CustomBgWrapper/CustomBgWrapper";
import { MobileFilterRow, MobileFilterSort } from 'shared/pages/explore/exploreView';
import { SortIcon } from 'shared/icons';
import { ProjectsSearchBar } from 'shared/components/projectsSearchBar/projectsSearchBar';
import { SortingTypeIndex } from 'shared/constants/sortingType';
import { AppTester } from 'supporting';
import { MagicBoxRow } from "../../../components/tagAdminProjectsSearchBar/tagAdminProjectsSearchBar";
import ResizedImageEnhanced from "../../../components/ResizedImageEnhanced";
import { useGetLimitSendCompetition } from 'shared/hooks/useGetLimitSendCompetition';
import { HsePolicies } from 'shared/constants/HsePolicies';
import { CompetitionEditFrameForbidden } from 'shared/components/error-frames';
import { PreShortListPage } from '_competition/pages/ShortListPage/PreShortListPage';
import ReactTooltip from "react-tooltip";
import { getTooltipStyles, tooptipStylesWhite } from "../../../constants/tooptipStyles";
import { BTagsGridNew } from "../../../../core/components/bTag/bTagsGridNew/bTagsGridNew";
import { SendProjectButton } from '_competition/components/SendProjectButton';
import { useModal } from 'core';
import { AccessModalTypes } from 'shared/modals/AccessModal/AccessModal';
import { useAuth } from 'core/auth';
import MetaTags from 'shared/components/MetaTags';

const BRIEF_ERROR_FORBIDDEN_MSG = 'This user is not approved to view this competition'

export enum TABS {
  about = 'about',
  jury = 'jury',
  projects = 'projects',
  shortlist = 'shortlist'
}
export enum SPECIALTABS {
  about = 'about',
  jury = 'jury',
  projects = 'projects',
  select = 'shortlist',
  shortlist = 'finalists',
}
export const CUSTOMTABS: { [key: string]: string } = {
  '1': 'about',
  '2': 'jury',
  '3': 'projects',
  '4': 'shortlist'
};

const DropdownText = styled(FInter.SmallTextBoldMagic) <{ isActive?: boolean, isDark?: boolean, isAcademy?: boolean }>`
  font-size: 13px;
  line-height: 18px;
  font-weight: 600;
  letter-spacing: -0.02em;
  
  ${({ isActive, theme, isDark, isAcademy }) => isActive ? css`
    color: ${isAcademy ? Colors.geoWhite100 : isDark ? theme.icon.hoverSpecialActive : theme.icon.active};
  ` : null}
`;
const TabletSortWrapper = styled(FlexBox)`
  gap: 8px;
  
`

const getUrl = (encodedState: string, ctx?: boolean) => {
  if (ctx) {
    const id = window.location.pathname.split('/')[2];
    return `/competition/${id}/context/${encodedState}`;
  }
  return `${window.location.pathname}`
}

interface CompetitionPageProps {
  id?: string;
}

// TODO потом удалить, Нурс временно попросил!!!!
export const COMPETITIONS_WITH_OPEN_PROJECTS = ['0439ccbea0944f25a6ea380c0c465bd6']

export const CompetitionPage: FC<CompetitionPageProps> = (props) => {
  //const isMobile = useIsMobile();
  const [{ tab }] = useQueryState();

  return (
    // <EncodedStateFilter getUrl={getUrl} ctx={isMobile && tab && tab === 'projects'}>
    <EncodedStateFilter getUrl={getUrl} ctx={tab && tab === 'projects'}>
      <GetCompetitionItem {...props} />
    </EncodedStateFilter>
  )
};

const GetCompetitionItem: FC<CompetitionPageProps> = ({ id: externalId }) => {
  const { id = externalId } = useParams<{ id: string }>();
  const { i18n, t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();
  const isMobile = useIsMobile();
  const is744BP = useBreakpoint(LayoutConst.screen.s);
  const is743BP = useBreakpoint(LayoutConst.screen.s - 1);
  const isMac13 = useBreakpoint(LayoutConst.screen.mac13);
  const theme1 = useTheme();
  const profile = useProfile();
  const { info } = useToasts();
  const breakpoint = useBreakpoint(576);
  const auth = useAuth();
  const modal = useModal();
  const {
    sorting,
    setSorting,
  } = useEncodedStateFilter();
  const [selectedTab, setSelectedTab] = useState('about');
  const [scroll, setScroll] = useState(false);
  const [target, setTarget] = useState('');
  const [briefForbiddenError, setBriefForbiddenError] = useState<any>(null)
  const [competition, setCompetition] = useState<Competition<'Local'>>();
  const [showMobileTags, setShowMobileTags] = useState(false);
  const [time, setTime] = useState(Date.now());
  const [isLoading, setIsLoading] = useState(false);
  const isAcademy = AppTester.isAcademy();
  const isGreenAward = AppTester.isGreenAward();
  const isDamuseum = AppTester.isDaMuseum();
  const isHSEDesign = AppTester.isHSEDesign();
  const isCompetitionRoute = !!useRouteMatch(LinkTo.competition);

  // const [customBGStorage, setCustomBGStorage] = useState(localStorage.getItem('lastCompetitionBG'))

  const customBGStorage = localStorage.getItem('lastCompetitionBG')

  const isCompetitionCompleted = useMemo(() => (competition && isCompetitionHasFinalyst(competition)), [competition])

  const initialTab = useMemo(() => (isCompetitionCompleted ? TABS.shortlist : TABS.about), [isCompetitionCompleted])

  const [{ tab: queryTab = initialTab, unrated }, setQueryParams] = useQueryState();
  const competitionStatus = getCompetitionStatus(competition);
  const bgColor = useMemo(() => (isAcademy ? '#2A3034' : (competition?.competitionColorTheme?.backgroundColor === '#FEFEFE' && competition?.isAutomatic) ? theme1.competition.bg : competition?.competitionColorTheme?.backgroundColor) || '#FEFEFE', [competition, theme1, isAcademy])

  const { theme, isDarkText } = createThemeByColor(bgColor, theme1);
  const isDarkTheme = useMemo(() => !isDarkText, [isDarkText])

  const [{ allowedInfo, allowedStatus }] = useGetLimitSendCompetition(competition ?? {} as Competition<'Local'>);

  // @ts-ignore
  const showPreShortList = competition?.nominations?.[0]?.showPreShortList;

  useEffect(() => {
    dispatch(HseContextActions.set({
      tabs: TABS,
      initialTab,
    }));
    return () => {
      dispatch(HseContextActions.reset({}));
    }
  }, [TABS, dispatch])


  useEffect(() => {
    if (!profile && queryTab !== initialTab) {
      setQueryParams({ tab: TABS.about }, { replace: true });
    }
  }, [profile])

  const [activeTabKey, setActiveTabKey] = useState(queryTab);

  const isModer = useMemo(() => {
    if (profile && competition) {
      const hasPolicyCompetitionModer = profile.rolesList && Array.isArray(profile.rolesList)
        && (new ProfileRole(HsePolicies.access_competitions)).containsIn(profile.rolesList);

      return (bProfile.isModer(profile) || hasPolicyCompetitionModer ||
        competition?.moderatorID?.includes(profile?.accountId) ||
        competition?.administratorID?.includes(profile?.accountId)
      )
    }
  }, [profile, competition])



  const isBriefModer = useMemo(() => ((profile && profile.rolesList && Array.isArray(profile.rolesList)
    && (new ProfileRole(HsePolicies.access_brief_competitions)).containsIn(profile.rolesList)) || undefined), [profile])

  const isCanSubmitOnBrief = useMemo(
    () => competition && !!competition?.isBriefCompetition &&
      allowedInfo && allowedInfo?.includes(CompetitionDisableBtnStatus.max_briefs), [competition, allowedInfo])

  //@ts-ignore
  const isAllowParticipants = useMemo(() => (competition?.allowEmptyParticipantRequests), [competition])

  const isParticipant = useMemo(
    //@ts-ignore
    () => (competition && competition?.participantAccountIds?.includes(profile?.accountId)), [competition, profile])

  const isPendingParticipant = useMemo(
    //@ts-ignore
    () => (competition && competition?.pendingParticipantsIds?.includes(profile?.accountId)), [competition, profile])

  const isJurySectionNeed = useMemo(() => (competition && competition.juryID && competition?.juryID?.length > 0), [competition]);
  const isProjectsTabsNeed = useMemo(
    () => (
      (competition && profile && competition?.juryID?.includes(profile?.accountId)) ||
      isModer || !!(isBriefModer && competition?.isBriefCompetition) || COMPETITIONS_WITH_OPEN_PROJECTS.includes(competition?.competitionId || '')), [competition, profile, isModer, isBriefModer])

  const hasFinalistText = useMemo(
    //@ts-ignore
    () => (![STATUSES.Open, STATUSES.Announcement].includes(competition?.status) && (!!competition?.winnerText_Final?.length || !!competition?.winnerText_Intro?.length)
    ), [competition]
  )

  const isCanViewPreRegistration = useMemo(
    //@ts-ignore
    () => (!!competition?.isPreRegistration && !competition?.participantAccountIds?.includes(profile?.accountId) && competition?.status === STATUSES.Open), [profile, competition])

  const isCanSubmitProjects = useMemo(
    () => (
      /*isParticipant || */
      isPendingParticipant ||
      (isCanSubmitOnBrief && !isModer) ||
      (!!allowedInfo?.length && !isModer
      ) ||
      competition?.status !== STATUSES.Open
    )
    , [
      isParticipant,
      competition,
      isCanSubmitOnBrief,
      isModer,
      isPendingParticipant,
      allowedInfo
    ]);

  // const isCanSubmitProjects = false
  const isJury = useMemo(() => profile && competition?.juryID?.includes(profile?.designerId), [competition, profile]);
  const isVsContext = useMemo(() => (competition && competition?.contexts?.includes('hsevisualresearch')), [competition]);
  const isCompetitionModer = useMemo(() => profile && competition?.moderatorID?.includes(profile?.designerId), [competition, profile]);

  // const isDarkTheme = useMemo(() => (competition?.competitionColorTheme?.backgroundColor === '#FEFEFE' && competition?.isNewType), [competition])
  const smHeight = useMemo(() => (window.innerHeight < LayoutConst.screen.height.projectCover), [])
  const is1440 = useMemo(() => (isMac13 || smHeight), [isMac13, smHeight]);

  const canViewCompetitionPoint = useMemo(() => (
    (isJury && isVsContext) || isModer || isCompetitionModer), [isJury, isCompetitionModer, isVsContext, isModer]);

  const onMobileSortingChange = useCallback(() => {
    setSorting(Number(sorting) === 1 ? 2 : 1);
    setTime(Date.now())
  }, [sorting])

  const onSortingChange = useCallback((s: SortingTypeIndex): void => {
    setSorting(s);
    setTime(Date.now());
  }, [setSorting])

  const searchBar = useMemo(
    () => (
      <ProjectsSearchBar
        isLoading={false}
        isCategoriesHidden={true}
        hideRightButtons
        hideLeftBar
        sorting={sorting}
        // hideRightBar={true}
        onSortingChange={onSortingChange}
        onToggleUnrated={() => { }}
        sortingMethods={canViewCompetitionPoint ? [1, 2, 13, ...(isJury ? [] : [])] : [1, 2]}
        isDarkTheme={isDarkTheme}
      />
    ),
    [onSortingChange, sorting, isMobile, sorting, canViewCompetitionPoint, isDarkTheme],
  );

  const MobileSearchBar = useMemo(
    () => (
      <MobileFilterRow
        // fixed={isMobile}
        importantWidth
        style={{
          marginTop: 0,
          justifyContent: 'flex-end',
          paddingTop: '0px',
          width: '100% !important'
        }}
      >
        <MobileFilterSort onClick={() => onMobileSortingChange()}>
          <SortIcon />
          {t(`sorting_type.${Number(sorting) === 1 ? 'latest' : Number(sorting) === 2 ? 'popular' : 'score'}`)}
        </MobileFilterSort>
      </MobileFilterRow>
    ), [isMobile, sorting])


  const UnratedBar = useMemo(() => {
    if (!(isJury && (activeTabKey === TABS.projects))) {
      return null;
    }
    return (
      <FlexBox style={{ justifyContent: 'flex-end', width: isMobile ? '100%' : 'initial' }} offsetTopMobile={0} offsetTop={is743BP ? 24 : 0} offsetRight={isMobile ? 0 : 16} offsetRightMobile={0}>
        <MagicBoxRow
          label={t('filter.unrated')}
          // checked={extraFilter?.globalType?.includes('employee') || extraFilter?.globalType?.length === 0}
          checked={Boolean(unrated)}
          style={{ margin: isMobile ? '0' : '0 0 0 0', color: isHSEDesign ? theme.text.label : theme.inputs.disabledColor }}
          onClick={() => {

            setQueryParams({
              unrated: unrated === 'true' ? '' : 'true',
              page: 1
            })
          }}
        />
      </FlexBox>
    )
  }, [unrated, setQueryParams, isMobile, activeTabKey, isJury])


  const competitionTabs = useMemo(() => {
    const tabs: Record<string, string> = {};
    const specialTabs: Record<string, string> = {};
    const infoTabs: Record<string, string> = {};
    if (showPreShortList) {
      Object.entries(SPECIALTABS).forEach(([key, val]) => {
        specialTabs[key] = t(`competition.tabs.${val}`)
      })
      return specialTabs
    }

    // @ts-ignore
    if (competition?.infoTabs?.length) {
      // @ts-ignore
      competition?.infoTabs.forEach(({ name, tabId, enable }: { name: string; tabId: string, enable: boolean }) => {

        if (isModer) {
          // временный костыль, ждем правки бэка
          if (CUSTOMTABS[tabId] === 'shortlist' && name === 'Шортлист') {
            infoTabs[CUSTOMTABS[tabId]] = t('competition.tabs.shortlist');
          } else {
            infoTabs[CUSTOMTABS[tabId]] = name;
          }
          return;
        }
        // временный костыль, ждем правки бэка
        if (enable || tabId === '1' || (tabId === '3' && isJury)) {
          if (CUSTOMTABS[tabId] === 'shortlist' && name === 'Шортлист') {
            infoTabs[CUSTOMTABS[tabId]] = t('competition.tabs.shortlist');
          } else {
            infoTabs[CUSTOMTABS[tabId]] = name;
          }
        }
      });
      return infoTabs;
    }

    Object.entries(TABS).filter((i) => {
      if (
        (i.includes('jury') && !isJurySectionNeed) ||
        (i.includes('projects') && !isProjectsTabsNeed) ||
        (i.includes('shortlist') && (!isCompetitionCompleted && !hasFinalistText))) {
        return false
      } else return i;
    }).map(([key, val]) => {
      tabs[key] = t(`competition.tabs.${val}`)
    })

    if (Object.keys(tabs)?.length === 1) {
      return {};
    }

    return tabs;
  }, [
    isJurySectionNeed,
    isCompetitionCompleted,
    isProjectsTabsNeed,
    hasFinalistText,
    is743BP,
    // @ts-ignore
    competition?.infoTabs,
    showPreShortList,
    isModer,
    isJury,
    t
  ]);
  //@ts-ignore
  const isPaidCompetition = useMemo(() => competition?.lmsModuleProjectId && competition?.isPaidApplication, [competition])

  const actionButtonVisible = useMemo(() => {
    if (isPaidCompetition) {
      return false
    }
    if (!!isModer || !!(isBriefModer && competition?.isBriefCompetition)) {
      return competitionStatus < COMPETITION_STATUSES.full_finish
    }

    return (competitionStatus === COMPETITION_STATUSES.default
      || competitionStatus === COMPETITION_STATUSES.deadline_soon)
  }, [competitionStatus])

  useEffect(() => {
    setActiveTabKey(queryTab);
  }, [queryTab]);

  useEffect(() => {
    if (id) {
      setIsLoading(true);
      CompetitionAPI.Get({ idCompetition: id, initWinner: true })
        .then((v) => v.json())
        .then((v) => {
          //@ts-ignore
          if (v?.['ErrorStatusCode'] === 500 && v?.['ErrorMessage'] === BRIEF_ERROR_FORBIDDEN_MSG) {
            //@ts-ignore
            setBriefForbiddenError(true)
            return;
          }
          return API.toLang<Competition<'Local'>>(v, i18n.language)
        })
        .then(setCompetition)
        .finally(() => {
          if (isGreenAward) {
            setTimeout(() => setIsLoading(false), 1000)
          } else {
            setIsLoading(false)
          }
        })

    }
  }, [id, i18n.language]);

  useEffect(() => {
    const updateActiveOnScroll = (value: string) => {
      setTarget("");
      setScroll(true);
      setSelectedTab(value);
    };

    const handler = () => {
      const { scrollHeight, clientHeight } = document.documentElement;
      const { scrollY } = window;

      if (scrollY + 1 >= scrollHeight - clientHeight) {
        updateActiveOnScroll('contacts');
      } else if (scrollY <= 800) {
        setTarget("");
        setScroll(false);
        setSelectedTab('about');
      } else if (scrollY > 800 && scrollY <= 1200 && !is744BP) {
        updateActiveOnScroll('about');
      } else if (scrollY > 1200 && scrollY <= 1500 && !is744BP) {
        updateActiveOnScroll('timing');
      } else if (scrollY > 800 && scrollY <= 1200 && is744BP) {
        updateActiveOnScroll('timing');
      } else if (scrollY > 1900 && scrollY <= 2600 && !is744BP) {
        updateActiveOnScroll('terms');
      } else if (scrollY > 1200 && scrollY <= 2400 && is744BP) {
        updateActiveOnScroll('terms');
      } else if (scrollY > 2600 && scrollY <= 4200) {
        updateActiveOnScroll('marks');
      } else if (scrollY > 2400 && scrollY <= 6800 && is744BP) {
        updateActiveOnScroll('marks');
      } else if (scrollY > 4200 && scrollY <= 5900 && !is744BP) {
        updateActiveOnScroll('prize');
      } else if (scrollY > 6800 && scrollY <= 7300 && is744BP) {
        updateActiveOnScroll('prize');
      } else if (scrollY > 5900 && scrollY <= 6200 && !is744BP) {
        updateActiveOnScroll('contacts');
      } else if (scrollY > 7300 && is744BP) {
        updateActiveOnScroll('contacts');
      }
    };

    window.addEventListener('scroll', handler);
    scrollFunc(target, is744BP);

    return () => {
      window.removeEventListener('scroll', handler);
    };
  }, [target, selectedTab, scroll, is744BP]);

  const titleImages = useMemo(() => {
    if (competition?.isBilingual) {
      return i18n.language === 'en' ? competition?.titleImages_en : competition?.titleImages
    }
    return competition?.titleImages;
  }, [competition, i18n.language])

  //хардкод для для конкурса
  const showArrowTabIcon = useMemo(() => {
    return competition && competition?.competitionId === '43bd8964119e473c9944c1ef43aee6f2'
  }, [competition])

  const isBriefPreregistration = useMemo(
    () => (!!competition?.isBriefCompetition && !!competition?.isPreRegistration && isCanViewPreRegistration), [competition, isCanViewPreRegistration])

  const buttonText = useMemo(
    () => {
      if (!!competition?.isBriefCompetition && !!competition?.isPreRegistration) {
        return t(`hse_showcases_title.competitions.msg.${isCanViewPreRegistration ? 'go_requests' : 'send_project'}`)
      }

      return competition?.enrollButtonText
    }, [t, competition, isCanViewPreRegistration])



  const handleCopy = () => {
    const linkText = window.location.href;
    navigator.clipboard.writeText(linkText)
      .then(() => {
        info(t('notifications.copy_msg-success'))
      })
      .catch(err => {
        info(t('notifications.copy_msg-error'))
      });
  }

  const handlePaidCompetitionClick = useCallback(() => {
    if (!profile) {
      auth.login();
    } else {
      API.request()
        .endpoint(Endpoints.geoGateway)
        .url('/api/LMS/RequestToJoinCourse')
        .addQuery('projectId', competition?.lmsModuleProjectId)
        .post()
        .send()
        .then(() => {
          modal.show("access", {
            type: AccessModalTypes.LMS,
            projectId: competition?.lmsModuleProjectId
          });
        })

    }
  }, [profile, auth, modal]);

  // Обработчики событий
  const onTabChange = (tab: string) => {
    if (isDamuseum && !isCompetitionRoute) {
      history.push(CreateLinkTo.competition(competition?.competitionId ?? ''))
    }
    setQueryParams({ tab });
  }

  const backgroundColor = isGreenAward
    ? 'linear-gradient(to right, #23423F, #87B444)'
    : (
      isAcademy
        ? '#2A3034'
        : (
          (competition?.competitionColorTheme?.backgroundColor === '#FEFEFE'
            && competition?.isAutomatic)
            ? theme.competition.bg
            : competition?.competitionColorTheme?.backgroundColor
        )
        || undefined
    )


  if (briefForbiddenError) {
    return (
      <CompetitionEditFrameForbidden id={''} />
    )
  }

  return (
    <>
      <MetaTags
        title={competition?.title}
        images={competition?.titleImages}
      />
      <ThemeProvider theme={theme as any}>
        <CustomBgWrapper isCompetition backgroundColor={
          backgroundColor
        }
        >
          <MainBlock isMobile={is744BP} isAcademy={isAcademy}>
            {competition?.isNewType ? (
              <HeaderBlock isMobile={is744BP}>
                <CompetitionView competition={competition} />
                <HeaderRightBlock isMobile={is744BP}>
                  <FlexBox width="100%" direction='column' directionMobile="column">
                    {/* {competition?.title && <TitleText isMobile={is743BP}>{competition?.title}</TitleText>} */}
                    {!is743BP && (<BTagsGridNew customShadowColor={backgroundColor} shadow>
                      {
                        competitionStatus === COMPETITION_STATUSES.full_finish || competitionStatus === COMPETITION_STATUSES.apply_finish ?
                          <StatusPseudoTag onClick={(e: any) => {
                            e.preventDefault()
                            e.stopPropagation()
                          }} mr={16} mb={12}>
                            {
                              t(competitionStatus === COMPETITION_STATUSES.full_finish ?
                                'competition.statuses.Competition_ended'
                                :
                                'competition.statuses.Competition_apply_ended')
                            }
                          </StatusPseudoTag>
                          :
                          undefined
                      }
                      {competition && [...competition.requredTags, ...competition.regularTags].map((v) => {
                        // @ts-ignore
                        const target = (v.tagId === AGEYTOMESH_TAG_ID || v.isTeamTag) ? '_blank' : '';
                        return (
                          // <LimitedLink key={v.tagId} to={CreateLinkTo.tag(v.tagId)} target={target}>

                          <BTag tag={v} educational={v.isEducationTag} organization={v.isTeamTag} isProjectsTag>
                            {bTag.title(v)}
                            <ReactTooltip {...getTooltipStyles(theme as any)} />

                          </BTag>
                          // </LimitedLink>
                        )
                      })}
                    </BTagsGridNew>)}
                  </FlexBox>
                  <FlexBox width="100%" direction='column' justify={'end'} directionMobile={'column'}>

                    {is743BP && (<FlexBox>
                      <BottomOuterMobile>
                        {
                          competitionStatus === COMPETITION_STATUSES.full_finish || competitionStatus === COMPETITION_STATUSES.apply_finish ?
                            <StatusPseudoTag
                              onClick={(e: any) => {
                                e.preventDefault()
                                e.stopPropagation()
                              }}
                              mr={8}>
                              {
                                t(competitionStatus === COMPETITION_STATUSES.full_finish ?
                                  'competition.statuses.Competition_ended'
                                  :
                                  'competition.statuses.Competition_apply_ended')
                              }
                            </StatusPseudoTag>
                            :
                            undefined
                        }
                        <FlexBox directionMobile='row'>
                          <FlexBox offsetRight={'12px'}>
                            <IconCompetitionSpecial onClick={handleCopy}>
                              <ShareIcon />
                            </IconCompetitionSpecial>
                          </FlexBox>
                        </FlexBox>
                        {!![...competition?.requredTags, ...competition?.regularTags]?.length && (
                          <div className="BottomOuterMobileActions">
                            <FlexBox directionMobile="row" gxMobile={12}>
                              <TagsMobBtn isCompetition customText={t('tags_mobile_btn_text').toLowerCase()} onClick={setShowMobileTags} flag={showMobileTags} />
                            </FlexBox>
                          </div>
                        )}
                      </BottomOuterMobile>

                    </FlexBox>)}
                    {is743BP && showMobileTags && (<FlexBox offsetTopMobile={'10px'}>
                      <TagsMobile show={showMobileTags}>
                        {competition && [...competition.requredTags, ...competition.regularTags].map((v) => {
                          // @ts-ignore
                          const target = (v.tagId === AGEYTOMESH_TAG_ID || v.isTeamTag) ? '_blank' : '';
                          return (
                            <LimitedLink key={v.tagId} to={CreateLinkTo.tag(v.tagId)} target={target}>
                              {/*@ts-ignore*/}
                              <BTag tag={v} educational={v.isEducationTag} organization={v.isTeamTag} isProjectsTag>
                                {bTag.title(v)}
                              </BTag>
                            </LimitedLink>
                          )
                        })}
                      </TagsMobile>
                    </FlexBox>)}
                    {!isMobile && competitionStatus === COMPETITION_STATUSES.deadline_soon && <DeadLineWarningWrapper>
                      <div><WarningIcon /></div>
                      <span>{t('competition.ten_days-remain_msg')}</span>
                    </DeadLineWarningWrapper>}
                    <FlexBox direction='row' directionMobile={'column'} width={'100%'} widthMobile={'100%'} justify='space-between' justifyMobile='space-between' align='flex-end' alignMobile='flex-start'>

                      {!is744BP && (
                        <FlexBox offsetBottom={0} offsetBottomMobile={16} direction='column' directionMobile='row' justifyMobile='space-between' widthMobile={'100%'} alignMobile='center' style={{ placeItems: 'center' }}>
                          <IconCompetitionSpecial onClick={handleCopy} style={{ marginBottom: 0, marginTop: (!isMobile && (competitionStatus === COMPETITION_STATUSES.default || competitionStatus === COMPETITION_STATUSES.deadline_soon)) ? 24 : 0 }}>
                            <ShareIcon />
                          </IconCompetitionSpecial>
                          {isMobile && competitionStatus === COMPETITION_STATUSES.deadline_soon && (
                            <DeadLineWarningWrapper>
                              <div><WarningIcon /></div>
                              <span>{t('competition.ten_days-remain_msg')}</span>
                            </DeadLineWarningWrapper>
                          )}
                        </FlexBox>
                      )}
                      {is743BP && competitionStatus === COMPETITION_STATUSES.deadline_soon && <DeadLineWarningWrapper>
                        <div><WarningIcon /></div>
                        <span>{t('competition.ten_days-remain_msg')}</span>
                      </DeadLineWarningWrapper>}
                      {actionButtonVisible && <FlexBox justify='flex-end' justifyMobile='flex-start' widthMobile={'100%'} offsetTopMobile={is744BP ? (showMobileTags ? 14 : 24) : 0}>
                        <ActionsButtons
                          isModer={!!isModer || !!(isBriefModer && competition?.isBriefCompetition)}
                          id={competition?.competitionId}
                          contexts={competition?.contexts}
                          //@ts-ignore
                          isPreRegistration={isCanViewPreRegistration}
                          isBriefPreregistration={isBriefPreregistration}
                          nominationId={competition?.nominationsID?.[0]}
                          disabled={isCanSubmitProjects && !isGreenAward}
                          isAllowParticipants={isAllowParticipants}
                          fullWidth={false}
                          needAuth={!profile}
                          //@ts-ignore
                          text={buttonText}
                          allowedInfo={allowedInfo}
                          allowedStatus={allowedStatus}
                        />
                      </FlexBox>}
                      {isPaidCompetition && (
                        <HintTooltip
                          text={t('hints.paid_competition_hint')}
                          positionY='top'
                          onWhiteBg
                        >
                          <SendProjectButton
                            color={theme.competition.buttonText}
                            className='moder-button'
                            c={theme.competition.buttonBg}
                            hoverC={theme.competition.secondaryText}
                            onClick={handlePaidCompetitionClick}
                            r="3"
                          >
                            {t('competition.request_member')}
                          </SendProjectButton>
                        </HintTooltip>
                      )}

                    </FlexBox>
                  </FlexBox>
                </HeaderRightBlock>
              </HeaderBlock>
            ) : (
              <HeaderBlockNotAuto isMobile={is744BP}>
                <FlexBox direction="column" directionMobile='column-reverse'>
                  <SmthTitle isMobile={is744BP}>
                    <TitleTextNotAuto isMobile={is744BP}>{competition?.title}</TitleTextNotAuto>
                  </SmthTitle>
                  <SmthBanner isMobile={is744BP}>
                    <ResizedImageEnhanced files={titleImages} />
                  </SmthBanner>
                </FlexBox>
                <FlexBox width="100%" height={'auto'} justify='space-between' justifyMobile='flex-end' direction='row' directionMobile='column-reverse'
                  style={{ maxWidth: '1152px', placeItems: 'end' }}>
                  <SmthIconsWrapperNotAuto>
                    <CopyIcon onClick={handleCopy} />
                  </SmthIconsWrapperNotAuto>
                  {actionButtonVisible && competition && <ActionsButtons
                    isModer={!!isModer || !!(isBriefModer && competition?.isBriefCompetition)}
                    id={competition?.competitionId}
                    contexts={competition?.contexts}
                    disabled={isCanSubmitProjects}
                    //@ts-ignore
                    isPreRegistration={isCanViewPreRegistration}
                    isAllowParticipants={isAllowParticipants}
                    isBriefPreregistration={isBriefPreregistration}
                    nominationId={competition?.nominationsID?.[0]}
                    fullWidth={breakpoint}
                    needAuth={!profile}
                    //@ts-ignore
                    text={buttonText}
                    allowedInfo={allowedInfo}
                    allowedStatus={allowedStatus}
                  />}
                </FlexBox>
              </HeaderBlockNotAuto>
            )}
            {is743BP && UnratedBar}
            <FlexBox width={'100%'} offsetTopMobile={16} offsetBottomMobile={'16px'} offsetBottom={!is1440 ? 4 : 0} justifyMobile='end'>
              {is743BP ? (
                <>
                  <FlexBox directionMobile='row' justifyMobile='space-between' widthMobile={'100%'} alignMobile='center'>
                    {!!Object.keys(competitionTabs)?.length && (
                      <Dropdown
                        offsetY={-2}
                        hideArrow
                        dark={isDarkTheme}
                        orientation={'left'}
                        target={
                          <ArrowTopIconWithText
                            fill={isDarkTheme ? theme.competition.secondaryText : undefined}
                            isCompetition={true}
                            text={competitionTabs[activeTabKey]}
                            shrimpIcon
                          />
                        }
                      >
                        {Object.keys(competitionTabs)?.map((key) => {
                          return (
                            <div key={key} onClick={() => {
                              if (key === activeTabKey) return false;
                              onTabChange(key);
                            }}>
                              <DropdownListItem
                                justify='space-between'
                                isActive={key === activeTabKey}
                              >
                                <DropdownText isDark={!!competition?.isNewType} isAcademy={isAcademy} isActive={key === activeTabKey}>
                                  {competitionTabs[key]}
                                </DropdownText>
                                <ApprovedIcon fill={theme.icon.active} display={key === activeTabKey} />
                              </DropdownListItem>
                            </div>
                          )
                        }
                        )}
                      </Dropdown>
                    )}
                    {activeTabKey === TABS.projects && MobileSearchBar}

                  </FlexBox>
                </>
              ) : (
                <FlexBox width={'100%'} offsetTop={!competition?.isNewType ? 20 : 0}>
                  <SlideNavigation
                    items={competitionTabs}
                    activeIndexKey={activeTabKey}
                    onChange={onTabChange}
                    //хардкод стрелки для конкруса
                    arrowIconId={showArrowTabIcon ? 'projects' : ''}
                    padding={24}
                    capitalize={true}
                  />
                  <TabletSortWrapper>
                    {UnratedBar}
                    {activeTabKey === TABS.projects && (isMobile ? MobileSearchBar : searchBar)}
                  </TabletSortWrapper>

                </FlexBox>
              )}
            </FlexBox>
            {(
              activeTabKey === TABS.about ? (
                <FlexBox offsetTopMobile={4} width={'100%'}>
                  {/*@ts-ignore*/}
                  <PSLongread project={competition} />
                </FlexBox>
              ) : activeTabKey === TABS.jury ? (
                <CompetitionJuryPage openLikeTab externalId={externalId} />
              ) : activeTabKey === TABS.projects ? (
                <CompetitionProjectsPage openLikeTab mobileSorting={sorting} onMobileSortingChange={setSorting} isDarkTheme={isDarkTheme} externalId={externalId} />
              ) : activeTabKey === TABS.shortlist ? (
                <ShortListPage showPreShortList={showPreShortList} openLikeTab externalId={externalId} />
              ) : activeTabKey === 'select' ? (
                <PreShortListPage activeTabKey={activeTabKey} showPreShortList={showPreShortList} openLikeTab externalId={externalId} />
              ) : (
                <>
                  {/*@ts-ignore*/}
                  <PSLongread project={competition} />
                </>
              )
            )}
            {!isLoading && actionButtonVisible && !(['projects', 'shortlist'].includes(queryTab)) && <ButtonsWrapper isMobile={is744BP} justify='flex-end' justifyMobile='flex-start' widthMobile={'100%'} offsetTopMobile={is744BP ? (showMobileTags ? 14 : 24) : 0}>
              <ActionsButtons
                isModer={!!isModer || !!(isBriefModer && competition?.isBriefCompetition)}
                id={competition?.competitionId}
                contexts={competition?.contexts}
                //@ts-ignore
                isPreRegistration={isCanViewPreRegistration}
                isBriefPreregistration={isBriefPreregistration}
                nominationId={competition?.nominationsID?.[0]}
                disabled={isCanSubmitProjects}
                isAllowParticipants={isAllowParticipants}
                fullWidth={false}
                needAuth={!profile}
                //@ts-ignore
                text={buttonText}
                allowedInfo={allowedInfo}
                allowedStatus={allowedStatus}
              />
            </ButtonsWrapper>}
          </MainBlock>
        </CustomBgWrapper>
      </ThemeProvider>
    </>
  );
};

export default GetCompetitionItem;
